export default __webpack_public_path__ + "static/media/GADT.8dee87df.png";